<script lang="ts" setup>
import type { DetailsCarItemDetails } from '@autobid/ui/types/components/CarDetails'
import { usePrepareDetailsCarData } from '@autobid/ui/composables/car/usePrepareDetailsCarData'
import { computed } from 'vue'

interface Props {
  details: DetailsCarItemDetails
}

const props = defineProps<Props>()

const { extras } = usePrepareDetailsCarData(
  computed(() => props.details),
)

const TWO_COLS_FROM = 12
</script>

<template>
  <div v-if="extras.display" class="col-span-12 lg:col-span-6">
    <SectionsDetailsElementsSection>
      <template #heading>
        {{ extras.title }}
      </template>

      <template #content>
        <SectionsDetailsElementsList
          v-if="extras.list.length"
          :elements="extras.list"
          :element-class="`w-full ${
            extras.list.length > TWO_COLS_FROM ? 'sm:w-1/2' : ''
          }`"
          :class="{
            'flex flex-wrap': extras.list.length > TWO_COLS_FROM,
          }"
        />

        <SectionsDetailsElementsHeading
          v-if="extras.freeTextHeading"
          class="w-[calc(100%+1.25rem)] -ml-[0.625rem] whitespace-pre-line text-sm !leading-5 md:!text-base mt-4 mb-2"
          variant="primary"
        >
          {{ extras.freeTextHeading }}
        </SectionsDetailsElementsHeading>

        <SectionsDetailsElementsFreeText
          v-if="extras.freeText.length"
          :has-border="extras.list.length > 0 && !extras.freeTextHeading"
          :free-text="extras.freeText"
        />
      </template>
    </SectionsDetailsElementsSection>
  </div>
</template>
